const trackParcer = (elm) => {
  if (!elm || !elm.dataset || !elm.dataset.trackerIdentifier || !(typeof track === "function")) return

  const type = elm.dataset.trackerIdentifier
  const templateName = document.querySelector("body").dataset.templateName

  switch (type) {
    case "faqItem":
      {
        let htmlOfElm = elm.dataset.trackerComponent
        htmlOfElm = !htmlOfElm ? elm : document.getElementById(htmlOfElm)
        let faqTitle = elm.dataset.trackerGlobalQuestionText
        const category = templateName.toUpperCase()

        // Opened or Closed
        let isExpanded = elm.getAttribute("aria-expanded")
        let status = isExpanded === "true" ? "Question Opened" : "Question Closed"
        track(category, status, {
          question: faqTitle,
        })
      }
      break
    case "CTA":
      {
        let targetURL = elm.getAttribute("href")
        let ctaType = elm.dataset.trackerCtaType
        let network = elm.dataset.trackerNetwork

        if (ctaType === "Hero") {
          track("Homepage", "Hero Slider CTA Clicked", {
            targetURL,
          })
        } else if (ctaType === "FAQ-QUESTION-CTA") {
          const category = templateName.toUpperCase()
          track(category, "Question CTA Clicked", {
            targetURL,
          })
        } else if (ctaType === "ARTICLE-NEWSLETTER") {
          if (templateName === "Stories Landing") {
            track("Stories", "Newsletter Subscribe CTA Clicked", {
              targetURL,
            })
          } else {
            track("Article", "Newsletter Subscribe CTA Clicked", {
              targetURL,
            })
          }
        } else if (templateName == "Product Homepage") {
          track("Products Overview", "CTA Clicked", {
            targetURL,
          })
        } else if (templateName == "E-Bike System Detail") {
          track("E-Groupsets", "CTA Clicked", {
            targetURL,
          })
        } else if (templateName == "Softgoods Detail") {
          track("Product", "CTA Clicked", {
            targetURL,
          })
        } else if (ctaType === "Hero-404") {
          track("404", "CTA Clicked", {
            targetURL,
          })
        } else if (ctaType === "logos") {
          track("Products Category Overview", "CTA Clicked", {
            targetURL,
            type: "logo",
          })
        }
        else if (ctaType === 'Story') {
          track(
            'Story',
            'CTA Clicked',
            {
              targetURL,
            },
            elm
          )
        }
        else if (ctaType === 'Navigation') {
          const isSubMenu = elm.dataset.subTarget;
          if (isSubMenu === "1") {
            track(
              'Level 1 Navigation',
              'opened'
            )
          }
          else {
            track(
              'Level 1 Navigation',
              'CTA Clicked',
              {
                targetURL,
              },
            )
          }

        }
        else if (ctaType === 'Article Newsletter') {
          track(
            'Article',
            'Newsletter Subscribe CTA Clicked',
            {
              targetURL,
            },
            elm
          )
        }
        else if (ctaType == 'Stories Landing Newsletter') {

          track(
            'Stories',
            'Newsletter Subscribe CTA Clicked',
            {
              targetURL,
            },
            elm
          )
        }
        else if (ctaType === 'CTA Title' && network) {
          track('Homepage', network + ' CTA Clicked', {
            targetURL,
          })
        }
      }
      break
    case "PAGE":
      {
        const main = document.querySelector("main")
        if (!main) return
      
        if (!main.dataset.feature) {
          console.log("Please add  <main data-feature='...'>")
          return
        }

        let targetURL = elm.getAttribute("href")
        let pageName = elm.dataset.trackerPageName
        let mainName = main.dataset.feature
        track(mainName, `${pageName} CTA Clicked`, {
          targetURL
        })
      }
      break
    case 'key-media':
      {
        let targetURL = elm.getAttribute('href')

        track('Homepage', 'Media Review CTA Clicked', {
          targetURL,
        })
      }
      break
    case "MENU-ITEM-SELECTOR":
      {
        let category = elm.dataset.trackerCategory
        let action = elm.dataset.trackerAction
        let targetURL = $(elm).attr("href")
        track(category, action, {
          targetURL,
        })
      }
      break
    case 'article-feed':
      {
        let targetURL = elm.getAttribute('href')
        let position = elm.dataset.trackerPosition
        let type = elm.dataset.trackerType
        let component = elm.dataset.trackerComponent

        if (position == '2') {
          position = $(elm).parent().index() + 1 //take individual position index of other articles
        }
        if (component == 'Article') {
          track('Article', 'Related Article Clicked', {
            targetURL,
          })
        } else {
          track('Homepage', 'Article Container CTA Clicked', {
            position,
            targetURL,
            type,
          })
        }
      }
      break
    case "FOOTER-CTA-SELECTOR":
      {
        let category = elm.dataset.trackerCategory
        let action = elm.dataset.trackerAction
        let position = elm.dataset.trackerPosition
        let linkGroup = elm.closest(".link-group")
        let sectionTitle = "N/A"
        if (linkGroup !== undefined || linkGroup !== null) {
          sectionTitle = linkGroup?.querySelector("[data-tracker-text]")?.dataset?.trackerText || "N/A"
        }

        let targetURL = elm.getAttribute("href")

        track(category, action, {
          sectionTitle,
          targetURL,
          position,
        })
      }
      break
    case "locale-selector":
      {
        const position = "header";
        const locale = elm.dataset.trackerCountry
        let action = elm.dataset.trackerAction

        if (action === "Selected") {
          action = `${locale} Selected`
        }

        track("Locale Selector", action, { position })
      }
      break
    case "FOOTER-APP":
      {
        track("Footer", "App Download Clicked", {
          targetURL: elm.getAttribute("href"),
        })
      }
      break
    case "FOOTER-SOCIAL":
      {
        track("Footer", "Social Account Clicked", {
          targetURL: elm.getAttribute("href"),
        })
      }
      break
    case "FOOTER-":
      {
        track("Footer", "Footer Register CTA Clicked", {
          targetURL: elm.getAttribute("href"),
        })
      }
      break
    case "website-selector-category":
      {
        track("Umbrella", "CTA Clicked", { targetURL: elm.getAttribute("href") })
      }
      break
    case 'TECHNOLOGIES-TAB-CTA':
      {
        let url = elm.getAttribute('href')
        track('Technologies', `CTA Clicked`, {
          targetURL: url,
        })
      }
      break
    case 'TECHNOLOGIES-TAB-SELECTOR':
      {
        let title = elm.dataset.trackerText
        track('Technologies', `Tab ${title} Selected`)
      }
      break
    case 'TECHNOLOGIES-HOTSPOT':
      {
        let isOpen = $(elm).hasClass('popover-open')
        let title = elm.dataset.trackerGlobalTitle
        let status = isOpen ? 'Closed' : 'Opened'

        track('Technologies', `Hotspot ${status}`, {
          hotspotTitle: title,
          hotspotType: 'detail',
        })
      }
      break
    case 'search-modal':
      {
        const event = elm.dataset.modalEvent
        if (event === 'opened') {
          track(
            'Search',
            `Opened`,
            {
              'page-position': 'Modal',
            },
            elm
          )
        } else if (event === 'closed') {
          track(
            'Search',
            `Closed`,
            {
              'page-position': 'Modal',
            },
            elm
          )
        }
      }
      break
    case 'search-modal-form':
      {
        const searchInput = elm.querySelector('#modal-search-input')
        if (searchInput) {
          const searchValue = searchInput.value
          track('Search', 'Search Submitted', { 'page-position': 'Modal', 'value-searched': searchValue }, elm)
        }
      }
      break
    case 'search-modal-form-checkbox':
      {
        if (elm.checked) {
          track('Search', 'Search Product Filter Selected', { 'page-position': 'Modal' }, elm)
        }
      }
      break
    case 'search-result':
      {
        const positionIndex = $(elm).parents('div').index() + 1
        const targetUrl = $(elm).attr('href')
        const title = $(elm).parents('div').attr('title')
        track(
          'Search',
          'Search Result Clicked',
          {
            result: {
              title,
              'page-position': 'Body',
              position: positionIndex,
              targetUrl,
            },
          },
          elm
        )
      }
      break
    case 'BIKE-RIDE':
      {
        const targetURL = elm.getAttribute('href');
        track('Bike Selector', 'Ride Test CTA Clicked', { targetURL }, elm);
      }
      break
    case 'BIKE-ALL-SPECS':
      {
        track('Bike Selector', 'Vendor CTA Clicked', { targetURL: elm.getAttribute('href') }, elm)
      }
      break
    case 'related-products':
      {
        if (templateName === 'Softgoods Detail') {
          track('Product', `Related Product Clicked`, {
            targetURL: elm.getAttribute('href'),
          })
        } else {
          let product_name = elm.dataset.trackerName
          track(
            'Related Products',
            `${product_name} Clicked`,
            {
              'page-position': 'Body',
            },
            elm
          )
        }
      }
      break
    case 'softgoods-cta':
      {
        track('Softgoods Home', `CTA Clicked`, { targetURL: elm.getAttribute('href') })
        break;
      }
    case 'components-overview-cta':
      {
        track('Components Overview', `CTA Clicked`, { targetURL: elm.getAttribute('href') })
        break;
      }
    case 'components-cta':
      {
        track('Components', `CTA Clicked`, { targetURL: elm.getAttribute('href') })
        break;
      }
    case 'product-overview':
      {
        track('Products Overview', `CTA Clicked`, { targetURL: elm.getAttribute('href') })
        break;
      }
    case 'groupsets-cta':
      {
        track('Groupsets', `CTA Clicked`, { targetURL: elm.getAttribute('href') })
        break;
      }
    case 'ARTICLE-RELATED-PRODUCT':
      {
        let targetURL = $(elm).attr('href')
        track('Article', 'Related Product Clicked', {
          targetURL,
        })
      }
      break
    case 'SHARE-ARTICLE':
      {
        const shareMethod = elm.dataset.trackerShareMethod
        if (shareMethod) {
          track('Article', 'Shared', { shareMethod })
        }
      }
      break
    case 'STORIES-LIST-CTA':
      {
        const articleType = elm.dataset.trackerGlobalCategoryText
        if (articleType) {
          track(
            'Stories',
            'CTA Clicked',
            {
              targetURL: elm.getAttribute('href'),
              articleType,
            },
            elm
          )
        }
      }
      break
    case 'TECHNOLOGIES-APP-DOWNLOAD':
      {
        track(
          'Technologies',
          'App Download Clicked',
          {
            targetURL: elm.getAttribute('href'),
          },
          elm
        )
      }
      break
    case 'Card':
      {
        let type = elm.dataset.trackerCardType;
        if (type == "SUPPORT-CARDS-CTA") {
          let targetURL = elm.getAttribute('href')
          let title = $(elm).parents('.container').find('h1,h2,h3,h4,h5,h6').html()
          track('Support', 'CTA Clicked', {
            targetURL,
            sectionTitle: title ? title : "General",
          })
        }
      }
    case 'SOCIAL':
      {
        let targetURL = elm.getAttribute('href')
        let network = elm.dataset.trackerNetwork

        track('Homepage', network + ' CTA Clicked', {
          targetURL,
        })
      }
      break
  }
}

export { trackParcer }

window.trackParcer = trackParcer

window.addEventListener("load", (e) => {
  const main = document.querySelector("main")
  if (!main) return

  if (!main.dataset.feature) {
    console.log("Please add  <main data-feature='...'>")
    return
  }

  let mainName = main.dataset.feature
  let pageTitle = document.title
  let pageUrl = window.location.href

  if (mainName != "pre-launch" && mainName != "launch 2") {
    track(
      mainName,
      "Loaded",
      {
        page: {
          title: pageTitle,
          url: pageUrl,
        },
      },
      document.body
    )
  }
})
